import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';

@JsonObject
export class Adresse {
  constructor (
    numTiers?: string,
    typeTiers?: string,
    numAdr?: number,
    raisonSociale?: string,
    ligneAdresse1?: string,
    ligneAdresse2?: string,
    ligneAdresse3?: string,
    codePostal?: string,
    ville?: string,
    typeAdr?: string,
    codeInsee?: string,
    libelleInsee?: string,
    codeDptg?: string,
    libelleDptg?: string,
    email?: string,
    numTel?: string,
    numTel2?: string,
    etat?: string
  ) {
    this.numTiers = numTiers as any;
    this.typeTiers = typeTiers as any;
    this.numAdr = numAdr as any;
    this.raisonSociale = raisonSociale as any;
    this.ligneAdresse1 = ligneAdresse1 as any;
    this.ligneAdresse2 = ligneAdresse2 as any;
    this.ligneAdresse3 = ligneAdresse3 as any;
    this.codePostal = codePostal as any;
    this.ville = ville as any;
    this.typeAdr = typeAdr as any;
    this.codeInsee = codeInsee as any;
    this.libelleInsee = libelleInsee as any;
    this.codeDptg = codeDptg as any;
    this.libelleDptg = libelleDptg as any;
    this.email = email as any;
    this.numTel = numTel as any;
    this.numTel2 = numTel2 as any;
    this.etat = etat as any;
  }

  @JsonProperty(String)
  numTiers?: string;

  @JsonProperty(String)
  typeTiers?: string;

  @JsonProperty(Number)
  numAdr?: number;

  @JsonProperty(String)
  raisonSociale?: string;

  @JsonProperty(String)
  ligneAdresse1?: string;

  @JsonProperty(String)
  ligneAdresse2?: string;

  @JsonProperty(String)
  ligneAdresse3?: string;

  @JsonProperty(String)
  codePostal?: string;

  @JsonProperty(String)
  ville?: string;

  @JsonProperty(String)
  typeAdr?: string;

  @JsonProperty(String)
  codeInsee?: string;

  @JsonProperty(String)
  libelleInsee?: string;

  @JsonProperty(String)
  codeDptg?: string;

  @JsonProperty(String)
  libelleDptg?: string;

  @JsonProperty(String)
  @Optional
  email?: string;

  @JsonProperty(String)
  numTel?: string;

  @JsonProperty(String)
  numTel2?: string;

  @JsonProperty(String)
  etat?: string;
}
